import { FEATURES } from '@/constants';

// Columns that are only available when a feature flag is enabled for the org.
const FEATURE_GATED_COLUMNS = {
  fundae_total_minutes_studied: FEATURES.FUNDAE_TOTAL_HOURS_STUDIED,
};

const isColumnEnabled = (column, rootGetters) => {
  const requiredFeature = FEATURE_GATED_COLUMNS[column.field_name];
  return !requiredFeature || rootGetters['features/canUseFeature'](requiredFeature);
};

const getters = {
  accessibleColumns: (state, gttrs, rootState, rootGttrs) =>
    state.columns.filter(column => isColumnEnabled(column, rootGttrs)),

  visibleColumns: (state, gttrs) => gttrs.accessibleColumns.filter(column => column.showColumn),

  selectableColumns: (state, gttrs) => gttrs.accessibleColumns,
};

export default getters;
